import Form from 'react-bootstrap/Form';
import { useEffect, useState } from 'react';

function ConsumersSearchForm({ search, searchKey, spinner }) {
  const [value, setValue] = useState(search);

  useEffect(() => {
    setValue(search);
  }, [search]);

  return (
    <Form.Control
      className="bo-search"
      name="search"
      id="search"
      placeholder="Search"
      disabled={spinner}
      value={value}
      onChange={e => setValue(e.target.value)}
      onKeyPress={e => searchKey('consumers', e)}
    />
  );
}

export default ConsumersSearchForm;
